<div class="container">
  <!-- FAD MASIVO DESKTOP-->
  <div class="fad-desktop">
    <div class="help-us">
      <img [src]="imgSrc" alt="Background Form">
      <p [innerHTML]="textTitle"></p>
      <img class="close" (click)="close(false)" src="assets/images/icon_cross.png" alt="Close">
    </div>
  </div>
</div>

<!-- FAD MASIVO MOVIL-->
<div class="fad-movil">
  <div class="box-container">
    <div class="content-res">
      <img class="close" (click)="close(false)" src="assets/images/icon_cross.png" alt="Close">
      <p [innerHTML]="textTitle"></p>
      <hr>
    </div>
  </div>
</div>

<!-- FORM RESPONSIVE HUBSPOT -->
<div class="container box-container">
  <div class="form-container">
    <app-form-template [type]="data.type" *ngIf="isPersonal()"></app-form-template>
    <app-form-company-template [type]="data.type" *ngIf="!isPersonal()"></app-form-company-template>
  </div>
</div>
